const videoConsentGivenEvent = new Event('videoconsentgiven');

export default class VideoDf1 {
  constructor(element, {} = {}) {
    if (!element) {
      return;
    }

    const playButton = element.querySelector('.video-df1__play-button');
    const consentButton = element.querySelector('.video-df1__consent-button');
    const video = element.querySelector('video');
    const iframe = element.querySelector('iframe');

    document.addEventListener(
      'videoconsentgiven',
      () => {
        sessionStorage.setItem('video_consent', 'yes');

        // Hide consent overlay
        element.classList.add('consent-given');
      }
    );

    if (playButton) {
      playButton.addEventListener('click', () => {

        // Hide play button
        element.classList.add('play-clicked');

        // Play native video
        if (video) {
          video.play();
        }

        // Play YouTube video
        if (iframe) {
          iframe.src += '&autoplay=1';
        }
      });
    }

    if (consentButton) {
      consentButton.addEventListener('click', () => {
        document.dispatchEvent(videoConsentGivenEvent);

        // Hide play button
        element.classList.add('play-clicked');

        // Play YouTube video
        if (iframe) {
          iframe.src += '&autoplay=1';
        }
      });
    }

    if (sessionStorage.getItem('video_consent') === 'yes') {
      document.dispatchEvent(videoConsentGivenEvent);
    }
  }
};
